import { render, staticRenderFns } from "./ParamsClone.vue?vue&type=template&id=2e79afed&"
import script from "./ParamsClone.vue?vue&type=script&lang=js&"
export * from "./ParamsClone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports